import React from 'react'
import ContentSection from '../../content_sections'
import BlogCard from '../blog_card'
// import Newsletter from '../newsletter'
import Pagination from '../pagination'
import { BlogList } from './style'

type AllBlogPostsProps = {
  pagination: Boolean
  posts: Array<PostProps>
  pageContext: any
  newsletterData: any
  lang: string
}

type PostProps = {
  node: {
    last_publication_date: string
    data: {
      theme: string
      reading_time: string
      title: { text: string }[]
      description: string
      image: {
        url: string
      }
      author: {
        primary: {
          name: string
          position: string
          photo: {
            url: string
          }
        }
      }[]
    }
    uid: string
  }
}

const AllBlogPosts = ({
  posts,
  pageContext,
  newsletterData,
  pagination,
  lang,
}: AllBlogPostsProps) => {
  const { numPages, localePath } = pageContext

  return (
    <>
      <ContentSection className="">
        {/* Uncomment the parts then delete the code block below when you want to display the newsletter again */}
        <BlogList>
          {posts.map((post, index) => {
            return (
              <li key={index}>
                <BlogCard
                  url={`${localePath}/${post.node.uid}`}
                  theme={post.node.data.theme}
                  reading_time={post.node.data.reading_time}
                  last_publication_date={post.node.last_publication_date}
                  title={post.node.data.title[0].text}
                  description={post.node.data.description}
                  image={post.node.data.image.url}
                  author={post.node.data.author[0].primary}
                  lang={lang}
                />
              </li>
            )
          })}
        </BlogList>
        {/* <BlogList>
          {posts.slice(0, 3).map((post, index) => {
            return (
              <li key={index}>
                <BlogCard
                  url={`${localePath}/${post.node.uid}`}
                  theme={post.node.data.theme}
                  reading_time={post.node.data.reading_time}
                  title={post.node.data.title[0].text}
                  description={post.node.data.description}
                  image={post.node.data.image.url}
                  author={post.node.data.author[0].primary}
                  lang={lang}
                />
              </li>
            )
          })}
        </BlogList> */}
        {/* </ContentSection> */}
        {/* <Newsletter newsletterData={newsletterData} /> */}
        {/* <ContentSection> */}
        {/* <BlogList>
          {posts.slice(3).map((post, index) => {
            return (
              <li key={index}>
                <BlogCard
                  url={`${localePath}/${post.node.uid}`}
                  theme={post.node.data.theme}
                  reading_time={post.node.data.reading_time}
                  title={post.node.data.title[0].text}
                  description={post.node.data.description}
                  image={post.node.data.image.url}
                  author={post.node.data.author[0].primary}
                  lang={lang}
                />
              </li>
            )
          })}
        </BlogList> */}
        {numPages > 1 && pagination && <Pagination pageContext={pageContext} />}
      </ContentSection>
    </>
  )
}

export default AllBlogPosts
